<template>
  <div id="platforms">
    <header>
      <div class="title">
        <h1>{{$t('map.transport.platforms.title')}}</h1>
        <p>{{$t('map.transport.platforms.directions')}}</p>
      </div>
      <div class="d-flex pt-5">
        <a
          v-if="prodFileUrl"
          :href="prodFileUrl"
          class="download-btn mr-5"
          download
          target="_blank"
        >{{$t('map.transport.platforms.downloadProd')}}</a>
        <a
          v-if="centralFileUrl"
          :href="centralFileUrl"
          class="download-btn"
          download
          target="_blank"
        >{{$t('map.transport.platforms.downloadCentral')}}</a>
      </div>
    </header>
    <!-- File input - pdf -->
    <div class="input-container">
      <label>{{$t('map.transport.platforms.prodFile')}}</label>
      <FileUploader
        :id="'prodFile'"
        :placeholder="$t('map.transport.platforms.filePH')"
        :type="'.pdf'"
        :label="$t('map.transport.platforms.browse')"
        :fileUrl="prodFileUrl"
        @setFile="setFile($event, 'prodFile')"
      />
      <div class="error-msg">
        <span v-if="$v.prodFile.$error">{{$t("map.transport.platforms.errors.fileRequired")}}</span>
      </div>
    </div>
    <div class="input-container">
      <label>{{$t('map.transport.platforms.centralFile')}}</label>
      <FileUploader
        :id="'centralFile'"
        :placeholder="$t('map.transport.platforms.filePH')"
        :type="'.pdf'"
        :label="$t('map.transport.platforms.browse')"
        :fileUrl="centralFileUrl"
        @setFile="setFile($event, 'centralFile')"
      />
      <div class="error-msg">
        <span v-if="$v.centralFile.$error">{{$t("map.transport.platforms.errors.fileRequired")}}</span>
      </div>
    </div>
    <!-- Drag & drop file -->
    <!-- <div
    v-if="!file"
    class="drop-container"
    v-on:dragover.prevent
    v-on:drop.prevent="dropGetFile">
      {{$t('map.transport.platforms.dropFile')}}
    </div>-->
    <div class="uploadInfo">{{uploadStatus}}</div>
    <button
      type="button"
      class="btn btn-dark control publish-btn"
      :disabled="isLoading"
      @click="validateForm"
    >{{$t('map.transport.platforms.upload')}}</button>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import API_SERVICE from "@/lib/api/platform";
import S3_Handler from "@/lib/api/s3_handler";
const FileUploader = () => import("@/components/FileUploader");
const api = new API_SERVICE();
const s3 = new S3_Handler();

export default {
  components: {
    FileUploader,
  },
  data: function () {
    return {
      isLoading: false,
      prodFile: null,
      prodFileUrl: null,
      centralFile: null,
      centralFileUrl: null,
      uploadStatus: "",
      signedURL: null,
    };
  },
  validations: {
    prodFile: {
      required,
    },
    centralFile: {
      required,
    },
  },
  beforeMount: async function () {
    await this.getFile();
  },
  methods: {
    getFile: async function () {
      this.isLoading = true;
      this.$store.commit("global/SET_LOADING", true);
      try {
        const response = await api.getPlatformFiles();
        const signedURLs = response.map((resp) => s3.getSignedUrl(resp.source));
        this.prodFileUrl = signedURLs[0];
        this.prodFile = signedURLs[0];
        this.centralFileUrl = signedURLs[1];
        this.centralFile = signedURLs[1];
        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    setFile: function (file, filetype) {
      this[filetype] = file;
      if (this.prodFile && this.centralFile) {
        this.uploadStatus = "Ready to upload";
      } else {
        this.uploadStatus = "Files missing";
      }
    },
    dropGetFile: function (event) {
      const file = event.dataTransfer.files[0];
      this.file = file;
      this.fileUrl = file.name;
      this.uploadStatus = "Ready to upload";
    },
    validateForm: async function () {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      await this.uploadFiles();
    },
    uploadFiles: async function () {
      this.isLoading = true;
      this.$store.commit("global/SET_LOADING", true);
      this.uploadStatus = "Uploading...";
      try {
        const timestamp = Date.now();
        let prodResp = null;
        let centralResp = null;
        if (typeof this.prodFile === "object") {
          const prodName = `${timestamp}_prod.pdf`;
          prodResp = await s3.uploadFile(prodName, this.prodFile);
        }
        if (typeof this.centralFile === "object") {
          const centralName = `${timestamp}_central.pdf`;
          centralResp = await s3.uploadFile(centralName, this.centralFile);
        }
        if (prodResp)
          await api.postPlatformFile(prodResp.Location, "prod_platform");
        if (centralResp)
          await api.postPlatformFile(centralResp.Location, "central_platform");
        this.uploadStatus = "Files uploaded";
        this.$store.commit("global/SET_LOADING", false);
        this.isLoading = false;
        this.file = null;
        this.fileUrl = null;
        this.$v.$reset();
        await this.getFile();
      } catch (error) {
        this.uploadStatus = "Error";
        this.$store.commit("global/SET_LOADING", false);
        this.isLoading = false;
        throw error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#platforms {
  background-color: $white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem 4rem;

  header {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .download-btn {
    background-color: $black;
    color: $white;
    border-radius: 0;
    padding: 0.5rem 2rem;
    align-self: center;
  }

  .input-container {
    width: 40%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 18px;
    margin: 1rem 0px;

    label {
      @extend %audi-b;
    }
  }

  .error-msg {
    color: $warn_red;
    font-size: 14px;
  }

  .drop-container,
  .uploadInfo {
    width: 80%;
    height: 6rem;
    background-color: $w_2;
    border: 1px solid $wg_2;
    align-self: center;
    margin: 3rem 0;
    padding: 1rem;
  }
  .drop-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .uploadInfo {
    overflow-y: scroll;
  }

  .publish-btn {
    align-self: flex-end;
    background: #000;
    border-radius: 0px;
    padding: 0.5rem 1rem;
  }
}
</style>